import Link from 'next/link';
import React from 'react';
import prepInternalUrl from '../lib/prepInternalUrl';

interface NavLinkProps {
  text: string;
  url: string;
  style?: React.CSSProperties;
}

const NavLink: React.FC<NavLinkProps> = ({ text, url, style }) => {
  if (!url) {
    return <span style={style}>{text}</span>;
  }

  const fixedUrl = prepInternalUrl(url);
  return (
    <Link href={fixedUrl} style={style}>
      {text}
    </Link>
  );
};

export default NavLink;
